export const bonuses = [
  {
    label: 'Bono 1',
    title: '20 clases listas para dictar',
    body: 'Clases desarrolladas con objetivos, contenidos, actividades y orientaciones didácticas. Elegí el tema, adaptalo y ahorrá horas de planificación.',
    highlight: 'Elegí → adaptá → enseñá',
  },
  {
    label: 'Bono 2',
    title: 'Banco de 150 preguntas de evaluación',
    body: 'Preguntas organizadas para crear cuestionarios, evaluar conocimientos y reforzar lo aprendido sin empezar desde cero.',
    highlight: 'Seleccioná → evaluá → reforzá',
  },
  {
    label: 'Bono 3',
    title: 'Atlas visual bomberil',
    body: 'Ilustraciones, esquemas y recursos gráficos para explicar conceptos técnicos de manera más clara y visual.',
    highlight: 'Mostrá → explicá → facilitá el aprendizaje',
  },
  {
    label: 'Bono 4',
    title: 'Kit de planillas del instructor',
    body: 'Planillas para organizar asistencias, actividades, evaluaciones y seguimiento de aspirantes.',
    highlight: 'Registrá → organizá → realizá el seguimiento',
  },
  {
    label: 'Bono 5',
    title: 'Planificador de capacitación anual',
    body: 'Organizá temas, clases y actividades durante el año con una estructura práctica y fácil de adaptar.',
    highlight: 'Planificá → programá → capacitá',
  },
];
